import { render, staticRenderFns } from "./ProjectBoards.vue?vue&type=template&id=3faa97a4&scoped=true"
import script from "./ProjectBoards.vue?vue&type=script&lang=js"
export * from "./ProjectBoards.vue?vue&type=script&lang=js"
import style0 from "./ProjectBoards.vue?vue&type=style&index=0&id=3faa97a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3faa97a4",
  null
  
)

export default component.exports